var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoteMark28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 84,
    viewBox: "23.574 11.431 59.852 83.846",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.426 11.431v41.923H64.242v41.923H23.574V53.354c0-23.219 18.697-41.923 41.907-41.923h17.945z",
    fill: "currentColor"
  })));
}
export default SvgRemoteMark28;